export default [
  {
    path: "/VU27c66lA4",
    name: "baice26.payments",
    meta: {
      title: "BAICE 2026 Payment(s)",
      authRequired: true,
      acc: ["y52481"],
    },
    component: () => import("@/views/baice/tws/payment/index.vue"),
  },
  {
    path: "/ff45320cbc20d754e0572b5167e86f4f85fec5c967470710",
    name: "baice26.pin.requests",
    meta: {
      title: "BAICE 2026 Pin Request(s)",
      authRequired: true,
      acc: [""],
    },
    component: () => import("@/views/baice/tws/payment/index2.vue"),
  },
  {
    path: "/7V937s4",
    name: "baice26.pin.transactions",
    meta: {
      title: "BAICE 2026 Pin purchase transactions",
      authRequired: true,
      acc: ["y9616915"],
    },
    component: () => import("@/views/baice/tws/payment/transactions.vue"),
  },
  {
    path: "/atKMg7",
    name: "baice26.pin.requests.transactions",
    meta: {
      title: "BAICE 2026 Pin Request",
      authRequired: true,
      acc: ["y9616915"],
    },
    component: () => import("@/views/baice/tws/payment/transactions2.vue"),
  },
];
